var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoFailedSeriesRecording = function SvgIcoFailedSeriesRecording(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    fill: "none",
    viewBox: "0 0 32 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M4 11c0 3.485 1.372 6.65 3.604 8.985A10 10 0 0 1 2 11a10 10 0 0 1 5.605-8.985A12.96 12.96 0 0 0 4 11m24 0c0 3.485-1.372 6.65-3.605 8.985A10 10 0 0 0 30 11a10 10 0 0 0-5.604-8.984A12.96 12.96 0 0 1 28 11",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M16 21c5.523 0 10-4.477 10-10S21.523 1 16 1 6 5.477 6 11s4.477 10 10 10m.096-14H13v8h1.763v-3.198h.87L17.305 15h2.113l-2.034-3.379q.847-.158 1.288-.745.441-.6.441-1.447 0-.7-.249-1.163a1.86 1.86 0 0 0-.655-.746 2.6 2.6 0 0 0-.96-.396A5 5 0 0 0 16.096 7m-.294 3.31h-1.04V8.493h1.153q.237 0 .486.033.25.034.44.136.193.09.317.271.124.18.124.486 0 .328-.146.509a.83.83 0 0 1-.35.27 1.8 1.8 0 0 1-.487.102q-.259.012-.497.012",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "m26.26 13.116 4.778 8.274a1.732 1.732 0 0 1-1.501 2.6zm0 0a1.732 1.732 0 0 0-3 0l-4.778 8.274zM19.984 23.99h9.554l-11.055-2.6a1.733 1.733 0 0 0 1.501 2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "m23.91 13.491-4.778 8.275a.983.983 0 0 0 .851 1.474h9.554a.983.983 0 0 0 .851-1.474l-4.777-8.275a.982.982 0 0 0-1.702 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.823 16.043h-.125a.555.555 0 0 0-.556.556v2.655c0 .307.25.556.556.556h.125a.556.556 0 0 0 .555-.556V16.6a.556.556 0 0 0-.555-.556M24.76 21.916a.618.618 0 1 0 0-1.236.618.618 0 0 0 0 1.236"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v24H0z"
  })))));
};
export default SvgIcoFailedSeriesRecording;